import React, { Component } from 'react'
import { Route, Switch } from 'react-router-dom'

import FollowUpsContainer from '../FollowUpsContainer'
import PaymentRequestContainer from '../PaymentRequestsContainer'
import AiasContainer from '../AiasContainer'
import InvoicesContainer from '../InvoicesContainer'

class DashboardRoutes extends Component {
  render() {
    const { selectedUser } = this.props
    return (
      <Switch>
        <Route
          exact
          path="/dashboard/follow-ups"
          render={() => <FollowUpsContainer selectedUser={selectedUser} />}
          selectedUser={this.props.selectedUser}
        />
        <Route
          exact
          path="/dashboard"
          render={() => <FollowUpsContainer selectedUser={selectedUser} />}
          selectedUser={this.props.selectedUser}
        />
        <Route
          exact
          path="/dashboard/payment-requests"
          render={() => <PaymentRequestContainer selectedUser={selectedUser} />}
        />
        <Route
          exact
          path="/dashboard/aias"
          render={() => <AiasContainer selectedUser={selectedUser} />}
        />
        <Route
          exact
          path="/dashboard/invoices"
          render={() => <InvoicesContainer selectedUser={selectedUser} />}
        />
      </Switch>
    )
  }
}

export default DashboardRoutes



// WEBPACK FOOTER //
// ./src/containers/dashboard/routes/routes.js